import { render, staticRenderFns } from "./resultado-financeiro.vue?vue&type=template&id=0d190c45&scoped=true&"
import script from "./resultado-financeiro.vue?vue&type=script&lang=js&"
export * from "./resultado-financeiro.vue?vue&type=script&lang=js&"
import style0 from "./resultado-financeiro.vue?vue&type=style&index=0&id=0d190c45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d190c45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
